// Automações · watcher email + daily digest + subscribers
import { db, auth } from '../client.js';
import { escapeHTML, DT, DATE, NUM } from '../shared.js';

const SUPABASE_URL = 'https://hbrvoairynwsliyxxgsg.supabase.co';
const SUPABASE_KEY = 'sb_publishable_a0ZR31NQNuDyXgm8uqoQ0g_DW96AQLB';

async function callEdge(fn, body = {}) {
  const { data: { session } } = await auth.auth.getSession();
  const token = session?.access_token || SUPABASE_KEY;
  const r = await fetch(`${SUPABASE_URL}/functions/v1/${fn}`, {
    method: 'POST',
    headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json', 'apikey': SUPABASE_KEY },
    body: JSON.stringify(body),
  });
  return await r.json();
}

export async function viewAutomacoes($c) {
  $c.innerHTML = `
    <header class="page-head">
      <div>
        <div class="kicker">PIPELINE AUTOMATIZADO</div>
        <h1>Automações · <strong>watchers e digest</strong></h1>
        <p class="lead">Watcher de e-mail (puxa XMLs de <span class="mono-inline">@binario.net</span>) e digest diário (envia resumo D-1 às 07h para diretoria). Tudo idempotente, com log auditável.</p>
      </div>
    </header>

    <div class="grid-2">
      <!-- WATCHER EMAIL XML -->
      <div class="card">
        <div class="card-head">
          <h2>Watcher de e-mail</h2>
          <span class="pill pill-mute" id="watcher-status">…</span>
        </div>
        <p class="text-sm text-mute" style="margin-bottom:14px;">Conecta ao Microsoft Graph na caixa <span class="mono-inline">wms@icaroexpress.com</span>, filtra e-mails de <span class="mono-inline">@binario.net</span> com anexo XML, ingere automaticamente. Marca como lido após processar.</p>
        <div class="row gap-sm">
          <button class="btn btn-blue" id="btn-watcher">⟳ Rodar watcher agora</button>
          <button class="btn-mini" id="btn-watcher-hist">histórico →</button>
        </div>
        <div id="watcher-result" style="display:none; margin-top:14px;"></div>
        <div id="watcher-hist" style="display:none; margin-top:16px;"></div>
      </div>

      <!-- DAILY DIGEST -->
      <div class="card">
        <div class="card-head">
          <h2>Digest diário</h2>
          <span class="pill pill-mute" id="digest-status">…</span>
        </div>
        <p class="text-sm text-mute" style="margin-bottom:14px;">E-mail HTML brand ZZYON com KPIs do dia anterior. Envia 07:00 BRT (configurar cron) ou sob demanda. Tracking de quem recebeu em <span class="mono-inline">daily_digest_run</span>.</p>
        <div class="row gap-sm">
          <button class="btn btn-blue" id="btn-digest-send">→ Enviar digest agora (D-1)</button>
          <button class="btn-mini" id="btn-digest-preview">prévia HTML</button>
          <button class="btn-mini" id="btn-digest-hist">histórico</button>
        </div>
        <div id="digest-result" style="display:none; margin-top:14px;"></div>
        <div id="digest-hist" style="display:none; margin-top:16px;"></div>
      </div>
    </div>

    <!-- DESTINATÁRIOS -->
    <div class="card mt-md">
      <div class="card-head">
        <h2>Destinatários do digest <span class="count" id="sub-count">…</span></h2>
        <button class="btn-mini" id="btn-add-sub">+ adicionar</button>
      </div>
      <div id="sub-form" style="display:none; padding: 14px; background: var(--bg-soft); border-radius: var(--r); margin-bottom: 16px;">
        <form id="form-sub" class="form-stack">
          <div class="grid-2">
            <label>E-mail<input id="sub-email" type="email" required placeholder="nome@binario.net"></label>
            <label>Nome<input id="sub-nome" placeholder="Maria Silva"></label>
            <label>Organização
              <select id="sub-org" required>
                <option value="binario">Binário</option>
                <option value="icaro">Ícaro</option>
                <option value="outro">Outro</option>
              </select>
            </label>
            <label>Cargo<input id="sub-cargo" placeholder="Diretor de Operações"></label>
            <label>Cadência
              <select id="sub-cad"><option value="diaria">diária</option><option value="semanal">semanal</option><option value="mensal">mensal</option></select>
            </label>
          </div>
          <div class="row gap-sm">
            <button type="submit" class="btn btn-blue">Adicionar</button>
            <button type="button" class="btn-mini" id="btn-cancel-sub">cancelar</button>
          </div>
        </form>
      </div>
      <div id="sub-list"></div>
    </div>

    <div class="card mt-md">
      <div class="card-head"><h2>Próximas automações na fila</h2></div>
      <table class="tbl">
        <thead><tr><th>Item</th><th>Estado</th><th>Quando entra</th><th>Para que serve</th></tr></thead>
        <tbody>
          <tr><td class="strong">Bot WhatsApp Cláudio</td><td><span class="pill pill-mute">backlog</span></td><td>Sprint 3</td><td>Foto da divergência via WhatsApp → registro automático</td></tr>
          <tr><td class="strong">PWA mobile conferente</td><td><span class="pill pill-mute">backlog</span></td><td>Sprint 4-5</td><td>Scan QR pela câmera no celular do conferente</td></tr>
          <tr><td class="strong">Forecast 30d + min/max</td><td><span class="pill pill-mute">backlog</span></td><td>Sprint 5</td><td>Reposição preditiva por SKU</td></tr>
          <tr><td class="strong">Acuracidade tempo real</td><td><span class="pill pill-mute">backlog</span></td><td>Sprint 6</td><td>Alerta &lt; 99,5% acuracidade</td></tr>
          <tr><td class="strong">API pública SAP</td><td><span class="pill pill-mute">backlog</span></td><td>Sprint 7</td><td>Binário consulta direto via SAP</td></tr>
        </tbody>
      </table>
    </div>
  `;

  // ─── WATCHER ──────────────────────────────────────────────────────────
  document.getElementById('btn-watcher').addEventListener('click', async () => {
    const btn = document.getElementById('btn-watcher');
    const res = document.getElementById('watcher-result');
    btn.disabled = true; btn.textContent = '⟳ rodando…';
    try {
      const j = await callEdge('binario-wms-mail-watcher', { trigger: 'manual' });
      res.style.display = 'block';
      if (j.dry_run) {
        res.className = 'msg warn';
        res.innerHTML = `<strong>⚠ Dry-run</strong> · ${escapeHTML(j.message)}<br><span class="mono-inline" style="font-size:11px;">${escapeHTML(j.next_step)}</span>`;
      } else if (j.ok) {
        res.className = 'msg ok';
        res.innerHTML = `<strong>✓</strong> ${j.emails_lidos} e-mails · ${j.anexos_xml} XMLs · ${j.nfes_ingeridas} NF-e ingeridas · ${j.erros} erros`;
      } else {
        res.className = 'msg err';
        res.innerHTML = `<strong>✕</strong> ${j.erros} erros`;
      }
      await loadStatus();
    } catch (e) { res.style.display='block'; res.className='msg err'; res.innerHTML=`<strong>✕</strong> ${escapeHTML(e.message)}`; }
    finally { btn.disabled = false; btn.textContent = '⟳ Rodar watcher agora'; }
  });

  document.getElementById('btn-watcher-hist').addEventListener('click', async () => {
    const wrap = document.getElementById('watcher-hist');
    wrap.style.display = wrap.style.display === 'block' ? 'none' : 'block';
    if (wrap.style.display === 'none') return;
    const { data: rows } = await db.from('mail_watch_run').select('*').order('iniciado_em', { ascending: false }).limit(10);
    if (!rows || rows.length === 0) { wrap.innerHTML = '<div class="empty">Sem execuções.</div>'; return; }
    wrap.innerHTML = `
      <table class="tbl">
        <thead><tr><th>Quando</th><th>Trig.</th><th class="num">E-mails</th><th class="num">XMLs</th><th class="num">NFs</th><th class="num">Erros</th><th>Nota</th></tr></thead>
        <tbody>${rows.map(r => `
          <tr>
            <td class="mono text-sm">${DT(r.iniciado_em)}</td>
            <td><span class="pill pill-mute">${escapeHTML(r.trigger_source || '—')}</span></td>
            <td class="num">${NUM(r.emails_lidos)}</td>
            <td class="num">${NUM(r.anexos_xml)}</td>
            <td class="num strong">${NUM(r.nfes_ingeridas)}</td>
            <td class="num"><span class="pill ${r.erros>0?'pill-red':'pill-green'}">${r.erros}</span></td>
            <td class="text-sm text-mute">${escapeHTML((r.notes || '').slice(0, 60))}</td>
          </tr>`).join('')}
        </tbody>
      </table>`;
  });

  // ─── DIGEST ───────────────────────────────────────────────────────────
  document.getElementById('btn-digest-send').addEventListener('click', async () => {
    const btn = document.getElementById('btn-digest-send');
    const res = document.getElementById('digest-result');
    btn.disabled = true; btn.textContent = '→ enviando…';
    try {
      const j = await callEdge('binario-wms-daily-digest', { trigger: 'manual' });
      res.style.display = 'block';
      if (j.dry_run) {
        res.className = 'msg warn';
        res.innerHTML = `<strong>⚠ Dry-run</strong> · ${escapeHTML(j.next_step)}<br>Renderizou para ${j.destinatarios} destinatário(s) mas não enviou (sem RESEND_API_KEY).`;
      } else if (j.ok) {
        res.className = 'msg ok';
        res.innerHTML = `<strong>✓</strong> ${j.enviados_ok}/${j.destinatarios} entregues · D-1: ${j.dia}`;
      } else {
        res.className = 'msg err';
        res.innerHTML = `<strong>✕</strong> ${j.enviados_erro} falhas: ${escapeHTML((j.erros || []).join(' · '))}`;
      }
      await loadStatus();
    } catch (e) { res.style.display='block'; res.className='msg err'; res.innerHTML=`<strong>✕</strong> ${escapeHTML(e.message)}`; }
    finally { btn.disabled = false; btn.textContent = '→ Enviar digest agora (D-1)'; }
  });

  document.getElementById('btn-digest-preview').addEventListener('click', async () => {
    const { data: { session } } = await auth.auth.getSession();
    const token = session?.access_token || SUPABASE_KEY;
    const r = await fetch(`${SUPABASE_URL}/functions/v1/binario-wms-daily-digest`, {
      method: 'POST',
      headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json', 'apikey': SUPABASE_KEY },
      body: JSON.stringify({ preview_only: true }),
    });
    const html = await r.text();
    const w = window.open('', '_blank');
    w.document.write(html);
    w.document.close();
  });

  document.getElementById('btn-digest-hist').addEventListener('click', async () => {
    const wrap = document.getElementById('digest-hist');
    wrap.style.display = wrap.style.display === 'block' ? 'none' : 'block';
    if (wrap.style.display === 'none') return;
    const { data: rows } = await db.from('daily_digest_run').select('*').order('enviado_em', { ascending: false }).limit(10);
    if (!rows || rows.length === 0) { wrap.innerHTML = '<div class="empty">Sem execuções.</div>'; return; }
    wrap.innerHTML = `
      <table class="tbl">
        <thead><tr><th>Enviado em</th><th>D-1</th><th class="num">Dest.</th><th class="num">OK</th><th class="num">Erro</th><th>Trig.</th></tr></thead>
        <tbody>${rows.map(r => `
          <tr>
            <td class="mono text-sm">${DT(r.enviado_em)}</td>
            <td class="mono text-sm">${DATE(r.periodo_d_menos_1)}</td>
            <td class="num">${NUM(r.destinatarios)}</td>
            <td class="num strong">${NUM(r.enviados_ok)}</td>
            <td class="num">${NUM(r.enviados_erro)}</td>
            <td><span class="pill pill-mute">${escapeHTML(r.trigger_source || '—')}</span></td>
          </tr>`).join('')}
        </tbody>
      </table>`;
  });

  // ─── SUBSCRIBERS ──────────────────────────────────────────────────────
  document.getElementById('btn-add-sub').addEventListener('click', () => {
    document.getElementById('sub-form').style.display = 'block';
  });
  document.getElementById('btn-cancel-sub').addEventListener('click', () => {
    document.getElementById('sub-form').style.display = 'none';
  });
  document.getElementById('form-sub').addEventListener('submit', async (e) => {
    e.preventDefault();
    try {
      await db.from('digest_subscriber').insert({
        email: document.getElementById('sub-email').value.toLowerCase().trim(),
        nome: document.getElementById('sub-nome').value || null,
        organizacao: document.getElementById('sub-org').value,
        cargo: document.getElementById('sub-cargo').value || null,
        cadencia: document.getElementById('sub-cad').value,
      });
      e.target.reset();
      document.getElementById('sub-form').style.display = 'none';
      await loadSubs();
    } catch (err) { alert('Erro: ' + err.message); }
  });

  async function loadSubs() {
    const { data: subs } = await db.from('digest_subscriber').select('*').order('organizacao').order('email');
    document.getElementById('sub-count').textContent = (subs || []).length;
    const listEl = document.getElementById('sub-list');
    if (!subs || subs.length === 0) {
      listEl.innerHTML = '<div class="empty">Nenhum destinatário cadastrado.</div>';
      return;
    }
    listEl.innerHTML = `
      <table class="tbl">
        <thead><tr><th>E-mail</th><th>Nome</th><th>Org.</th><th>Cargo</th><th>Cadência</th><th>Último envio</th><th></th></tr></thead>
        <tbody>${subs.map(s => `
          <tr data-id="${s.id}">
            <td class="mono">${escapeHTML(s.email)}</td>
            <td>${escapeHTML(s.nome || '—')}</td>
            <td><span class="pill ${s.organizacao === 'binario' ? 'pill-green' : 'pill-blue'}">${escapeHTML(s.organizacao)}</span></td>
            <td>${escapeHTML(s.cargo || '—')}</td>
            <td>${escapeHTML(s.cadencia)}</td>
            <td class="mono text-sm">${s.ultimo_enviado ? DT(s.ultimo_enviado) : '—'}</td>
            <td><button class="btn-mini" data-toggle="${s.id}" data-ativo="${s.ativo}">${s.ativo ? 'desativar' : 'ativar'}</button></td>
          </tr>`).join('')}
        </tbody>
      </table>`;
    listEl.querySelectorAll('[data-toggle]').forEach(b => b.addEventListener('click', async () => {
      const id = parseInt(b.dataset.toggle, 10);
      const ativo = b.dataset.ativo === 'true';
      await db.from('digest_subscriber').update({ ativo: !ativo }).eq('id', id);
      await loadSubs();
    }));
  }

  async function loadStatus() {
    try {
      const [{ data: w }, { data: d }] = await Promise.all([
        db.from('mail_watch_run').select('finalizado_em,erros').order('iniciado_em', { ascending: false }).limit(1),
        db.from('daily_digest_run').select('enviado_em,enviados_erro').order('enviado_em', { ascending: false }).limit(1),
      ]);
      const wpill = document.getElementById('watcher-status');
      if (!w || !w.length) { wpill.className = 'pill pill-mute'; wpill.textContent = 'nunca rodou'; }
      else if (w[0].erros > 0) { wpill.className = 'pill pill-red'; wpill.textContent = w[0].erros + ' erros'; }
      else { wpill.className = 'pill pill-green'; wpill.textContent = '● ativo'; }
      const dpill = document.getElementById('digest-status');
      if (!d || !d.length) { dpill.className = 'pill pill-mute'; dpill.textContent = 'nunca enviado'; }
      else if (d[0].enviados_erro > 0) { dpill.className = 'pill pill-amber'; dpill.textContent = d[0].enviados_erro + ' falhas'; }
      else { dpill.className = 'pill pill-green'; dpill.textContent = '● ativo'; }
    } catch (_e) { /* */ }
  }

  await loadStatus();
  await loadSubs();
}
